import React, {Component} from 'react';
//import Loox from '@bit/honeycombwax.products.loox';
import Loox from '../../ReposLib/src/UI/Loox/Loox.js';
import {default as ControlPanel} from './ControlPanel/Container';
import Actions from '../../actions/Actions.js';
//import Properties from './Properties';
import {default as Properties} from './Properties/Container';
import { default as CartItemPrice } from './Price/Container';
import SubscriptionInfo from './SubscriptionInfo';
import Discounts from './Discounts';
import * as Products from '../../libraries/Products.js';
import './style.css';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    let thumbnail = Products.getThumbnailURL(this.props.data.featured_image.url);
    let title = this.props.data.product_title;
    let product = Products.getProductByVariantID(this.props.data.variant_id);

    //console.log( this.props.data );
    
    return (
      <React.Fragment>
        <tr>
          <td className="text-center img_container p-0">
            <img src={thumbnail} className="thumbnail" alt={title}/>
            <div className="icon remove" onClick={()=>Actions.productUpdate({item:this.props.data,id:this.props.data.variant_id,quantity:0})}>
              X
            </div>
          </td>
          <td className="text-left content p-1 px-3">
            <div className="product_title">
              {(() => {
                if (this.props.data.final_price===0) {
                  return title;
                }
                else return <a href={"/products/"+this.props.data.handle+"?variant="+this.props.data.variant_id} target="_blank" rel="noopener noreferrer">{title}</a>
              })()}
            </div>
            {(() => {
              if ( this.props.data.variant_title!==null ) {
                return (
                  <div className="product_variant_title">{this.props.data.variant_title}</div>
                )
              }
            })()}
            {(() => {
              if ( product!==null && typeof product.metas.loox!=="undefined" ) {
                return (
                  <Loox
                      dataRating={product.metas.loox.avg_rating}
                      dataReviews={product.metas.loox.num_reviews}
                  />
                )
              }
            })()}
            <CartItemPrice data={this.props.data} data_product={product}/>
            <SubscriptionInfo data={this.props.data}/>
            <Properties data={this.props.data} properties={this.props.data.properties}/>
            <Discounts data={this.props.data}/>
            <div className="cart_item_control_panel_container">
              <ControlPanel
                item={this.props.data}
                data={this.props.data}
                variant_id={this.props.data.variant_id}
                quantity={this.props.data.quantity}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="py-2">
            <hr className="mx-3 my-1"/>
          </td>
        </tr>
      </React.Fragment>
    )
  };
}
export default Container;